const eu = {
  app: {
    title: 'BFPE Token DApp',
    subtitle: 'BFPE tokena Hyperledger Besu-n erabiltzeko Web3 aplikazioa',
  },
  nav: {
    tokens: 'Tokenak',
    nfts: 'NFTak',
    tutorial: 'Tutoriala',
    docs: 'Dokumentazioa',
  },
  lang: {
    es: 'Castellano',
    eu: 'Euskera',
    en: 'English',
  },
  wallet: {
    connect: 'Zorroa konektatu',
    connecting: 'Konektatzen...',
    connected: 'Zorroa konektatuta',
    chainId: 'Kate IDa',
    address: 'Helbidea',
    balance: 'Saldoa',
    copy: 'Helbide osoa kopiatu',
    copied: 'Kopiatuta!',
    switchNetwork: 'Besu sareak aldatu (ID: {chainId})',
    disconnect: 'Deskonektatu',
    // WalletConnect component
    title: 'Zorroaren Konexioa',
    connectedBadge: 'Konektatuta',
    switchBtn: 'Besu sareak aldatu (Kate ID: {chainId})',
    description: 'Konektatu zure zorroa BFPE Token kontratua Hyperledger Besu-n erabiltzeko.',
    note: 'Oharra:',
    noteText: 'Ziurtatu MetaMask instalatuta eta Hyperledger Besu sarearako konfiguratuta duzula.',
    addressLabel: 'Kontuaren Helbidea',
    chainIdLabel: 'Kate IDa',
    notDetected: 'Ez da detektatu',
    disconnectBtn: 'Zorroa deskonektatu',
  },
  tokenInfo: {
    title: 'Tokenaren Informazioa',
    refresh: 'Eguneratu',
    name: 'Izena',
    symbol: 'Sinboloa',
    totalSupply: 'Hornidura Totala',
    yourBalance: 'Zure Saldoa',
    status: 'Egoera',
    paused: 'Pausatuta',
    active: 'Aktibo',
    contractAddress: 'Kontratuaren Helbidea',
    configRequired: 'Konfigurazioa beharrezkoa:',
    configMessage: 'Mesedez konfiguratu kontratuaren helbidea .env fitxategian',
  },
  transfer: {
    title: 'Tokenak Transferitu',
    noWallet: 'Konektatu zure zorroa tokenak transferitzeko',
    recipientLabel: 'Hartzailearen Helbidea',
    recipientPlaceholder: '0x...',
    amountLabel: 'Kantitatea (BFPE)',
    amountPlaceholder: '0.0',
    errNoWallet: 'Mesedez konektatu zure zorroa lehenik',
    errInvalidAddress: 'Hartzailearen helbide baliogabea',
    errInvalidAmount: 'Kantitate baliogabea',
    successTitle: 'Transferentzia arrakastatsua!',
    successTx: 'TX: {hash}',
    toastLoading: 'Tokenak transferitzen...',
    toastSuccess: '{amount} BFPE arrakastaz transferitu dira!',
    toastError: 'Errorea tokenak transferitzean',
    processing: 'Prozesatzen...',
    submit: 'Tokenak Transferitu',
  },
  faucet: {
    title: 'Token Iturria',
    noWallet: 'Konektatu zure zorroa token doakoak eskatzeko',
    amountLabel: 'Eskaerako Kantitatea',
    cooldownLabel: 'Itxaronaldia',
    hours: '{n} ordu',
    nextRequest: 'Hurrengo eskaera erabilgarri:',
    availableNow: 'Orain tokenak eska ditzakezu!',
    errNoWallet: 'Mesedez konektatu zure zorroa lehenik',
    errCooldown: 'Itxaron behar duzu token gehiago eskatu aurretik',
    successTitle: 'Tokenak arrakastaz jaso dira!',
    successTx: 'TX: {hash}',
    toastLoading: 'Iturritik tokenak eskatzen...',
    toastSuccess: 'Tokenak arrakastaz jaso dira!',
    toastError: 'Errorea iturritik tokenak eskatzean',
    processing: 'Prozesatzen...',
    submit: '{amount} BFPE eskatu',
    infoPrefix: 'ℹ️ Informazioa:',
    infoText: '{hours} orduro token doakoak eska ditzakezu. Tokenak automatikoki transferituko dira zure zorroera transakzioa berretsi ondoren.',
    contractLabel: 'BFPE Token Kontratua',
    copyAddress: 'Helbidea kopiatu',
    importMetaMask: 'BFPE inportatu MetaMask-en',
  },
  mintBurn: {
    title: 'Mint & Burn',
    noWallet: 'Konektatu zure zorroa tokenak sortu edo erretzeko',
    mintTitle: 'Tokenak Sortu (Mint)',
    burnTitle: 'Tokenak Erre (Burn)',
    recipientLabel: 'Hartzailearen Helbidea',
    recipientPlaceholder: '0x...',
    amountLabel: 'Kantitatea (BFPE)',
    burnAmountLabel: 'Erretzeko Kantitatea (BFPE)',
    amountPlaceholder: '0.0',
    errNoWallet: 'Mesedez konektatu zure zorroa lehenik',
    errInvalidAddress: 'Helbide baliogabea',
    errInvalidAmount: 'Kantitate baliogabea',
    mintSuccessTitle: 'Mint arrakastatsua!',
    burnSuccessTitle: 'Burn arrakastatsua!',
    successTx: 'TX: {hash}',
    mintToastLoading: 'Tokenak sortzen (mint)...',
    mintToastSuccess: '{amount} BFPE arrakastaz sortu dira!',
    mintToastError: 'Errorea tokenak sortzean. Egiaztatu jabea zarela.',
    burnToastLoading: 'Tokenak erretzen (burn)...',
    burnToastSuccess: '{amount} BFPE arrakastaz erre dira!',
    burnToastError: 'Errorea tokenak erretzeean',
    processing: 'Prozesatzen...',
    mintSubmit: 'Tokenak Sortu',
    burnSubmit: 'Tokenak Erre',
  },
  admin: {
    title: 'Administrazio Panela',
    noWallet: 'Konektatu zure zorroa administrazio panelera sartzeko',
    notOwner: 'Kontratuaren jabeak soilik sar daitezke funtzio hauetara.',
    isOwner: '✅ Kontratuaren jabea zara',
    transfersTitle: 'Transferentzia Kontrola',
    currentStatus: 'Uneko egoera:',
    paused: 'Pausatuta',
    active: 'Aktibo',
    successTitle: 'Eragiketa arrakastatsua!',
    successTx: 'TX: {hash}',
    resumeToastLoading: 'Transferentziak berriro hasten...',
    resumeToastSuccess: 'Transferentziak berriro hasi dira!',
    pauseToastLoading: 'Transferentziak pausatzen...',
    pauseToastSuccess: 'Transferentziak pausatu dira!',
    pauseToastError: 'Errorea pausa egoera aldatzean',
    processing: 'Prozesatzen...',
    resumeBtn: 'Transferentziak Berriro Hasi',
    pauseBtn: 'Transferentziak Pausatu',
    ownershipTitle: 'Jabetza Transferitu',
    newOwnerLabel: 'Jabearen Helbide Berria',
    newOwnerPlaceholder: '0x...',
    errInvalidAddress: 'Helbide baliogabea',
    ownershipSuccessTitle: 'Jabetza transferitu da!',
    ownershipToastLoading: 'Jabetza transferitzen...',
    ownershipToastSuccess: 'Jabetza arrakastaz transferitu da!',
    ownershipToastError: 'Errorea jabetza transferitzean',
    warningLabel: '⚠️ Abisua:',
    warningText: 'Ekintza hau itzulezina da. Administrazio pribilegio guztiak galduko dituzu.',
    ownershipSubmit: 'Jabetza Transferitu',
  },
  events: {
    title: 'On-Chain Gertaerak',
    pause: 'Pausatu',
    resume: 'Berriro hasi',
    clear: 'Garbitu',
    waiting: 'Gertaerak itxaroten... Transakzioak hemen agertuko dira.',
    unknownEvent: '{event} {block} blokean',
    mintMsg: 'Mint {value} BFPE → {to}',
    burnMsg: 'Burn {value} BFPE ← {from}',
    transferMsg: 'Transfer {value} BFPE: {from} → {to}',
    faucetMsg: 'Faucet {amount} BFPE → {to}',
  },
  tutorial: {
    title: 'Tutorial Interaktiboa',
    subtitle: 'Ikasi BFPE DApp erabiltzen pausoz pauso',
    progress: 'Tutorialaren Aurrerapena',
    completed: '{done}/{total} osatuta',
    prev: 'Aurrekoa',
    next: 'Hurrengoa',
    markDone: 'Osatuta ✓',
    practice: 'Praktikatzera joan →',
    tip: '💡 Aholkua:',
    steps: [
      {
        title: '1. Konektatu zure Zorroa',
        tab: 'tokens',
        icon: '🦊',
        content: 'Blockchainarekin elkarreragiteko, zorro bat behar duzu. MetaMask da ezagunena. Instalatu nabigatzaile hedapen gisa eta konektatu "Zorroa konektatu" sakatuta eskuineko goiko izkinan.',
        tip: 'MetaMask BFPE Mainnet sarearako konfiguratu behar da: RPC URL https://bfpe-mainnet.blockchain.tkn.eus, Chain ID 1337, Sinboloa: BFPE. Aplikazioak automatikoki eskainiko dizu sarea aldatzea beste batean zaudela detektatzen badu.',
      },
      {
        title: '2. Eskatu Iturriaren Tokenak',
        tab: 'tokens',
        icon: '💧',
        content: 'Iturria (faucet) probetarako token doakoak banatzen dituen mekanismoa da. Joan Tokenak atalera eta sakatu "Eskatu" BFPE tokenak jasotzeko. Eskaera batetik bestera itxaronaldi bat dago gehiegikeriak saihesteko.',
        tip: 'Sare errealetan, iturri horiek testnets-etan soilik existitzen dira garatzaileek kontratuak kosturik gabe probatu ahal izateko. BFPE Mainnet-eko iturria hezkuntza-xederako da eta kontratuaren jabeak mugatua du.',
      },
      {
        title: '3. Transferitu Tokenak',
        tab: 'tokens',
        icon: '📤',
        content: 'Bidali BFPE tokenak beste Ethereum helbide batera. Sartu hartzailearen helbidea (0x... formatua) eta kantitatea. Transakzioa betirako eta aldaezin gordeko da blockchain-ean.',
        tip: '"Transfer" gertaera bat sortzen du ERC20 kontratuan transferentzia bakoitzak. Transakzioen historia osoa ikusi dezakezu bloke-esploratzailean: esploratzaile.blockchain.tkn.eus',
      },
      {
        title: '4. Token Mint & Burn',
        tab: 'tokens',
        icon: '🔥',
        content: 'Kontratuaren jabeak BFPE token berriak sortu (mint) eta hornidura totala handitu dezake. Edozein erabiltzailek bere tokenak erre (burn) ditzake, betirako suntsituz eta hornidura murriztuz.',
        tip: 'Mint-ek totalSupply handitzen du eta burn-ek murrizten. Mekanismo hori token baten politika monetarioaren oinarria da. Jabeak soilik (0x9e6d0B27762BfCD7d8913C9474583d715672ee87) mint ditzake token berriak.',
      },
      {
        title: '5. Administrazio Panela',
        tab: 'tokens',
        icon: '🛡️',
        content: 'Kontratuaren jabearen zorroa konektatzen baduzu, Admin Panela ikusiko duzu. Handik token transferentzia guztiak pausatu ditzakezu, iturriaren itxaronaldia eta kantitatea konfiguratu, edo jabetza beste helbide batera transferitu.',
        tip: 'OpenZeppelin-en Ownable ereduak bermatzen du helbide batek soilik duela administrazio-pribilegioa. Kontratua pausatuta dagoenean, ez da transferentziarik exekutatu daiteke — ezta jabeak ere ezin du tokenak transferitu.',
      },
      {
        title: '6. Meatu NFT bat',
        tab: 'nfts',
        icon: '🎨',
        content: 'NFTak (Non-Fungible Tokens) token bakarrak eta errepikaezinak dira. Joan NFTak atalera, sartu metadatuen URI bat (JSON edo irudirako esteka) eta sakatu "NFTa Meatu". Meatzaritzaren prezioa 0.5 BFPE da.',
        tip: 'MetaMask-ek bi transakzio eskatuko ditu: lehenik 0.5 BFPE gastua NFT kontratuari onartzea (approve ERC20), eta gero meatzaritza-eragiketa. Metadatuak normalean IPFS-ko JSON bat izaten dira: name, description eta image eremuak.',
      },
      {
        title: '7. Kudeatu zure Bilduma',
        tab: 'nfts',
        icon: '📦',
        content: '"Nire NFTak" atalean dituzun NFT guztiak ikusiko dituzu beren Token ID bakarrarekin. MetaMask-era inportatu ditzakezu "MetaMask-en Inportatu" botoiarekin zure zorroetan ikusteko, edo merkatuan zerrendatu prezio bat adieraziz.',
        tip: 'NFT bat zerrendatzeko bi transakzio behar dira (1/2 pausoa eta 2/2 pausoa): lehenik Marketplace kontratuari baimena ematen diozu zure NFTa zure izenean transferitzeko (approve ERC721), eta gero prezioarekin zerrendatzen duzu.',
      },
      {
        title: '8. NFT Merkatua',
        tab: 'nfts',
        icon: '🏪',
        content: 'Merkatu deszentralizatuak erabiltzaileen artean NFTak erosi eta saltzea ahalbidetzen du. Saltzaileek beren NFTak BFPE prezioarekin zerrendatzen dituzte. Erosteko, erosleak BFPE gastua onartzen du eta gero erosketa berresten du.',
        tip: 'Ordainketa BFPE tokenetan egiten da, ETH natiboan ez (Besu sareak ez du ETH natiboa). Plataformak salmenta bakoitzeko %2,5eko tasak kobratzen du jabearentzat. Marketplace kontratua: 0x6b3afb8A91fB704ACb187A96057fc1B28Ae24B0B',
      },
      {
        title: '9. Gertaera Panela',
        tab: 'tokens',
        icon: '📡',
        content: 'Gertaera-panelak denbora errealean erakusten ditu blockchain-ean gertatzen diren eragiketa guztiak: transferentziak, mint-ak, burn-ak, iturri-eskaerak... Automatikoki eguneratzen da bloke berri bakoitzarekin.',
        tip: 'Solidity gertaerak dira blockchain-ean gertatzen dena indexatzeko modu nagusia. esploratzaile.blockchain.tkn.eus bezalako bloke-esploratzaileek transakzioen historia eraikitzeko erabiltzen dituzte.',
      },
      {
        title: '10. Bloke Esploratzailea',
        tab: 'tokens',
        icon: '🔍',
        content: 'BFPE sareak bere esploratzaile propioa du non transakzio guztiak, kontratu hedatuak, tokenak eta gertaerak ikus ditzakezun. Sartu esploratzaile.blockchain.tkn.eus-en edozein eragiketa ikuskatzeko.',
        tip: 'Sareko kontratu aktiboak: BFPE Token (0xf556f877Eb8E66393e6F044B2196490A267967bD), NFT BFPENFT (0x0230fF20f9A10359e97683732694a947B1e9EfF5), Merkatua (0x6b3afb8A91fB704ACb187A96057fc1B28Ae24B0B).',
      },
    ],
  },
  mintNFT: {
    title: 'NFTa Meatu',
    noWallet: 'Konektatu zure zorroa NFTak meatzeko',
    mintPriceLabel: 'Meatzaritzaren prezioa:',
    contractLabel: 'NFT Kontratua:',
    dragDrop: 'Arrastatu fitxategi bat hona edo klik egin hautatzeko',
    formats: 'Formatuak: JPG, PNG, GIF, WEBP, PDF · Irudiak 20 MB arte (5 MB-ra konprimatzen dira) · PDFak 5 MB arte',
    fileAriaLabel: 'Hautatu NFT fitxategia',
    previewAlt: 'Aurrebista',
    removeAriaLabel: 'Ezabatu hautatutako fitxategia',
    compressionWarning: 'Irudia 5 MB baino handiagoa da eta automatikoki konprimatuko da igotzean.',
    uploadSuccess: 'Fitxategia arrakastaz igo da',
    uploadError: 'Errorea fitxategia igotzean',
    errFormat: 'Formatu baimengabea. Onartutako formatuak: JPG, PNG, GIF, WEBP, PDF',
    errPdfSize: 'PDF fitxategiak ezin dira 5 MB baino handiagoak izan',
    errImgSize: 'Irudiak ezin dira 20 MB baino handiagoak izan',
    errNoWallet: 'Mesedez konektatu zure zorroa lehenik',
    errNoFile: 'Mesedez igo fitxategi bat lehenik',
    approveLoading: 'BFPE gastua onartzen...',
    approveSuccess: 'Onarpena berretsia',
    mintLoading: 'NFTa meatzen...',
    mintSuccess: 'NFTa arrakastaz meatu da!',
    mintError: 'Errorea NFTa meatzean',
    uploadingBtn: 'Igotzen...',
    uploadingCompressingBtn: 'Igotzen eta konprimatzen...',
    uploadBtn: 'Fitxategia igo',
    mintingBtn: 'Meatzen...',
    mintBtn: 'NFTa Meatu · {price} BFPE',
    mintSuccessTitle: 'NFTa arrakastaz meatu da!',
    viewExplorer: 'Esploratzailean ikusi',
    nameLabel: 'NFTaren izena',
    namePlaceholder: 'Adib: Nire lehen artelan',
    descLabel: 'Deskribapena (aukerakoa)',
    descPlaceholder: 'Deskribatu zure NFTa...',
    errNoName: 'NFTaren izena beharrezkoa da',
  },
  myNFTs: {
    title: 'Nire NFTak',
    noWallet: 'Konektatu zure zorroa zure NFTak ikusteko',
    empty: 'Oraindik ez duzu NFTrik',
    emptySubtext: 'Meatu zure lehen NFTa hasteko',
    nftTitle: 'NFT #{id}',
    tokenId: 'Token IDa: {id}',
    creator: 'Sortzailea: {address}',
    listed: 'Zerrendatuta',
    importBtn: 'MetaMask-en Inportatu',
    tokenUriLabel: 'Token URI:',
    pricePlaceholder: 'Prezioa BFPE-tan',
    errInvalidPrice: 'Mesedez sartu prezio baliodun bat',
    errNoMetaMask: 'MetaMask ez dago erabilgarri',
    errImport: 'Ezin izan da NFTa inportatu: {message}',
    step1Loading: '1/2 pausoa — Marketplace-ari NFTa transferitzeko baimena ematen...',
    step1Success: '1/2 pausoa osatuta ✓',
    step2Loading: '2/2 pausoa — NFTa Merkatuan argitaratzen...',
    step2Success: 'NFTa Merkatuan argitaratu da!',
    listingBtn: 'Zerrendatzen...',
    listBtn: 'Merkatuan Zerrendatu',
  },
  marketplace: {
    title: 'NFT Merkatua',
    noWallet: 'Konektatu zure zorroa merkatua ikusteko',
    empty: 'Ez dago NFTrik zerrendatuta',
    emptySubtext: 'Izan zaitez NFT bat zerrendatzen lehena',
    nftTitle: 'NFT #{id}',
    seller: 'Saltzailea: {address}',
    creator: 'Sortzailea: {address}',
    tokenUri: 'Token URI:',
    priceLabel: 'Prezioa',
    yourNFT: 'Zure NFTa',
    approveLoading: 'BFPE gastua onartzen...',
    approveSuccess: 'Onarpena berretsia',
    buyLoading: 'NFTa erosten...',
    buySuccess: 'NFTa arrakastaz erosi da!',
    buyingBtn: 'Erosten...',
    buyBtn: 'NFTa Erosi',
  },
  nftPage: {
    configTitle: 'Konfigurazioa Beharrezkoa',
    configMessage: 'Mesedez konfiguratu NFT kontratuen helbideak .env fitxategian:',
    configNote: 'Exekutatu',
    configNote2: 'kontratuak hedatzeko.',
    title: 'NFT Bilduma eta Merkatua',
    subtitle: 'Meatu, bildu eta merkataratu NFTak',
  },
  docs: {
    title: 'Dokumentazioa',
    subtitle: 'Blockchain, Smart Contracts eta Web3-ren kontzeptu giltzarriak',
    categories: [
      {
        category: 'Oinarrizko Kontzeptuak',
        items: [
          {
            title: 'Zer da Blockchain?',
            content: 'Blockchain ordenagailu-sare batean transakzioak erregistratzen dituen liburu kontable digital banatua da. Bloke bakoitzak aurreko blokearen hash-a dauka, kate aldaezin bat sortuz. Ez dago zerbitzari zentralik; nodo guztiek kopia berdina mantentzen dute.',
          },
          {
            title: 'Zer da Hyperledger Besu?',
            content: 'Hyperledger Besu Linux Fundazioaren pean garatutako kode irekiko Ethereum bezero bat da. EVM (Ethereum Virtual Machine)-rekin bateragarria da eta sare publikoak zein pribatuak/baimenduak onartzen ditu. Enpresa eta hezkuntza-ingurunetarako egokia.',
          },
          {
            title: 'Zer da Zorro bat?',
            content: 'Zorrotxo batek (MetaMask bezalako) zure gako pribatuak gordetzen ditu eta transakzioak sinatzeko aukera ematen dizu. Zure helbide publikoa (0x...) zure kontu-zenbakia bezala da, eta zure gako pribatua zure pasahitza bezala. INOIZ ez partekatu zure gako pribatua.',
          },
          {
            title: 'Zer da Gas?',
            content: 'Gas-a EVMn eragiketak exekutatzeko beharrezkoa den lan konputazionala neurtzen duen unitatea da. Eragiketa bakoitzak gas-kostu bat du. Gure Besu garapen-sarean gas-prezioa 0 da, beraz transakzioak doakoak dira.',
          },
        ],
      },
      {
        category: 'Tokenak eta Estandarrak',
        items: [
          {
            title: 'ERC-20 (Token Fungiblea)',
            content: 'ERC-20 token fungibluentzako (trukatzeko modukoak) estandarra da. transfer(), approve(), transferFrom(), balanceOf(), totalSupply() bezalako funtzioak definitzen ditu. Gure BFPE Token-ek OpenZeppelin erabiliz estandar hau inplementatzen du, mint, burn, pausa eta iturriaren funtzionalitateekin.',
          },
          {
            title: 'ERC-721 (NFT)',
            content: 'ERC-721 token ez-fungibluentzako (bakarrak) estandarra da. Token bakoitzak ID bakarra du eta metadatuak lotuta eduki ditzake (irudia, izena, etab.). Funtzio nagusiak: ownerOf(), safeTransferFrom(), approve(), tokenURI(). Gure BFPENFTk ERC721 + ERC721URIStorage + ERC721Enumerable inplementatzen ditu.',
          },
          {
            title: 'Zer da OpenZeppelin?',
            content: 'OpenZeppelin auditatu eta probatutako smart contract-en liburutegia da. ERC-20, ERC-721, sarbide-kontrola (Ownable), segurtasuna (ReentrancyGuard, Pausable) eta gehiagoren inplementazio estandarrak eskaintzen ditu. OpenZeppelin erabiltzeak inplementazio pertsonalizatuen aurrean ahultasun-arriskua izugarri murrizten du.',
          },
        ],
      },
      {
        category: 'Smart Contracts',
        items: [
          {
            title: 'Zer da Smart Contract bat?',
            content: 'Smart contract bat blockchain-ean exekutatzen den programa bat da. Hedatu ondoren, bere kodea aldaezina da. Erabiltzaileek transakzioak bidaliz elkarreragiten dute. Kontratuak egoera bat du (aldagaiak) blockchain-ean betirako gordetzen dena.',
          },
          {
            title: 'Zer da ABI bat?',
            content: 'ABI (Application Binary Interface) smart contract batekin nola elkarreragin definitzen duen interfazea da. Funtzioak, haien parametroak eta itzultze-motak deskribatzen dituen JSON bat da. Frontend-ak ABI behar du zer funtzio dei ditzakeen eta datuak nola kodetu/deskodetu jakiteko.',
          },
          {
            title: 'Gertaerak (Events)',
            content: 'Gertaerak smart contract-ek exekuzioan zehar igortzen dituzten log-ak dira. Merkeak dira gordetzeko eta aplikazioei blockchain-ean gertatzen dena "entzuteko" aukera ematen diete. Adibidez, Transfer bakoitzak from, to eta value-rekin gertaera bat igortzen du.',
          },
          {
            title: 'Aldatzaileak (Modifiers)',
            content: 'Aldatzaileak (modifiers) funtzioei baldintzak gehitzen dizkieten dekoratzaileak dira. Adibidez, onlyOwner-ek kontratuaren jabeak soilik exekuta dezakeela eskatzen du. whenNotPaused-ek exekuzioa galarazten du kontratua pausatuta dagoenean.',
          },
        ],
      },
      {
        category: 'Merkatua eta DeFi',
        items: [
          {
            title: 'Nola funtzionatzen du Merkatuak?',
            content: '1) Saltzaileak merkatuari bere NFTa transferitzeko baimena ematen dio (approve). 2) listNFT() deitzen du prezioarekin. 3) Erosleak buyNFT() deitzen du ETH bidaliz. 4) Kontratuak NFTa erosleari transferitzen dio, ordainketa saltzaileari (tasaren kenketa eginda), eta tasa merkatu jabeari.',
          },
          {
            title: 'Approve + Transfer Eredua',
            content: 'Ethereum-en, kontratu batek ezin ditu tokenak zuzenean "hartu". Jabeak lehenik kontratuari baimena eman behar dio (approve) bere tokenak mugitzeko. Bi urratseko eredu hau funtsezkoa da ERC-20 zein ERC-721-en.',
          },
          {
            title: 'ReentrancyGuard',
            content: 'Reentrancy kontratu gaizto batek funtzio batera berriro deitzen duen erasoa da lehen exekuzioa amaitu aurretik ("The DAO" hackearen kasua). OpenZeppelin-eko ReentrancyGuard-ek dei errekurtsiboak blokeatuz hau saihesten du.',
          },
        ],
      },
      {
        category: 'Garapen Tresnak',
        items: [
          {
            title: 'Hardhat',
            content: 'Hardhat Ethereum-erako garapen-ingurunea da. Solidity kontratuak konpilatzeko, testak exekutatzeko, kontratuak hedatzeko eta arazkatzeko aukera ematen du. Garapenerako tokiko sare bat dauka. Proiektu honetan Besu-n konpilatzeko eta hedatzeko erabiltzen dugu.',
          },
          {
            title: 'Web3.js',
            content: 'Web3.js Ethereum nodoekin elkarreragiteko aukera ematen duen JavaScript liburutegia da. Transakzioak bidaltzeko, kontratu funtzioak deitzeko, saldoak kontsultatzeko, gertaerak entzuteko eta abarrerako metodoak eskaintzen ditu. Frontend-a eta blockchain-a lotzen dituen zubi da.',
          },
          {
            title: 'MetaMask',
            content: 'MetaMask zorro eta Web3 hornitzaile gisa jarduten duen nabigatzaile hedapena da. window.ethereum objektua injektatzen du DApps-ei erabiltzailearen kontuetarako sarbidea eskatu eta transakzioak sinatzeko aukera emanez.',
          },
          {
            title: 'Docker',
            content: 'Docker-ek azpiegitura osoa (Besu, deployer, frontend) kontainer isolatuetan exekutatzeko aukera ematen du. Honek erreproduzibilitatea errazten du: ikasleak komando bakar batekin ingurune osoa abiaraz dezake.',
          },
        ],
      },
    ],
  },
};

export default eu;
